import cookies from 'js-cookie';
import MJSSDK from '@mfex/mjssdk';
import siteConfig from 'site-config';
import axios from 'common/ajax';
import EventBus from 'common/event-bus';
import {TUserInfo} from 'common/mai-typing';
import constants from 'common/constant';
const {USER_SEX} = constants;

const {SYN_APP_LOGIN, SET_WEBVIEW_SESSION, IS_LOGIN} = siteConfig.API;
const isMamaApp = MJSSDK.UA.mamaApp;

/**
 * 由于非买后端MAI（cookies中baby_mode）/app/bi/大UC孕育状态不统一，前端需要做一次映射
 *
 * 各端对孕育状态的定义
 *    MAI域     App     Bi      UC
 备孕   0       3       1       1
 怀孕   1       1        2      2
 宝宝   2       2        3      3
 无宝宝                         4
 其他                           0
 * */

// 获取用户怀孕状态 appModeMap:app
export function getBabyMode(appToUC): Promise<TUserInfo> {
    const ua = MJSSDK.UA;
    appToUC = appToUC || false;
    // const uid = cookies.get('user_id');
    const babyMode = cookies.get('baby_mode'); // mai用户年龄:用户怀孕状态baby_mode 0备孕 1怀孕 2育儿 （从cookies拿）
    const appToUCMap = {3: 1, 1: 2, 2: 3};
    return new Promise(resolve => {
        if (ua.mamaApp && ua.pregnancyhelper && MJSSDK.compareVer('7.5.0') !== -1) {
            // 孕育 7.5.0 以上才支持 getUserInfo
            MJSSDK.invocation({
                action: 'getUserInfo', // 功能，参考附录一
                version: '1.0.0', // 版本，参考附录一，表无则表示非必需
                data: {}, // 传值 APP [可选]，参考附录一
                success: function (res) {
                    let mode = res.mode;
                    if (appToUC) {
                        mode = appToUCMap[res.mode]; // app孕育状态值映射成大UC
                    }
                    resolve({
                        userType: mode, // APP 返回数据 3备孕 1怀孕 2育儿
                        bbbirthday: res.bbbirthday,
                        preparePtDate: res.prepare_pt_date,
                        userSex: parseInt(res.rel) // 1妈妈 2爸爸
                    });
                }
            });
        } else {
            const maiToApp = {0: 3, 1: 1, 2: 2};
            let mode = maiToApp[babyMode]; // 非买孕育状态映射成app
            if (appToUC) {
                mode = appToUCMap[mode]; // app孕育状态值映射成大UC
            }
            resolve({
                userType: mode || '',
                bbbirthday: cookies.get('bbbirth') || '',
                userSex: USER_SEX.UNKNOW, // 1妈妈 2爸爸 0不知道
                preparePtDate: ''
            });
        }
    });
}

// 获取未登陆用户状态
export function getNoLoginUserInfo() {
    return new Promise(resolve => {
        getBabyMode(true).then(({userType, bbbirthday}) => {
            resolve({userType, bbbirthday} as TUserInfo);
        });
    });
}

export function isNoLoginInPregnancyhelper() {
    const uid = cookies.get('user_id');
    const ua = MJSSDK.UA;
    return !uid && ua.pregnancyhelper;
}

export function getUserId() {
    return cookies.get('user_id') || '';
}
/**
 * app登录回调
 */
export function appLogin(code: string, href: string) {
    return new Promise(function (resolve) {
        // 发异步请求将code传到非买后台
        axios
            .jsonp(SYN_APP_LOGIN, {
                params: {
                    code,
                    source: 0,
                    url_link: encodeURIComponent(href)
                }
            })
            .then(res => {
                if (Number(res.status) === 1 && Number(res.needSetWebViewSession) === 1) {
                    // 发异步请求到大UC setWebViewSession
                    axios.jsonp(`${SET_WEBVIEW_SESSION}?${res.params}`).then(ress => {
                        resolve(ress);
                    });
                } else {
                    resolve(res);
                }
            });
    });
}

/**
 * 调起登录
 */
export function login(fullpath?: string): void {
    const href = fullpath ? `${location.origin}/m${fullpath}` : location.href;
    if (isMamaApp) {
        MJSSDK.openLogin({
            enforceRefresh: false,
            success: function (res) {
                const code = String(res.code) || '';
                appLogin(code, href).then(() => {
                    location.href = href;
                });
            }
        });
    } else {
        const callbackUrl = `${siteConfig.API_BASE_URL}/mapi/member/loginCallBack?redirectUrl=${encodeURIComponent(
            href
        )}`;
        MJSSDK.openLogin({
            callbackUrl: callbackUrl
        });
    }
}

/**
 * 退出登录
 */
// export function logout(): void {
//     location.href = `${PASSPORT_WAP_LOGOUT_URL}?service=${encodeURIComponent(location.href)}`;
// }

/**
 * 登录拦截
 */
export async function loginIntercept(fullpath?: string) {
    let res = {};
    if (EventBus.isLogin === -1) {
        res = await axios.get(IS_LOGIN);
        EventBus.isLogin = (res['data'] || {}).code === 0 ? 1 : 0;
    }
    if (EventBus.isLogin === 0) {
        login(fullpath);
    }
    return EventBus.isLogin;
}
